import { render, staticRenderFns } from "./orderMgt.vue?vue&type=template&id=f342791c&scoped=true&"
import script from "./orderMgt.vue?vue&type=script&lang=js&"
export * from "./orderMgt.vue?vue&type=script&lang=js&"
import style0 from "./orderMgt.vue?vue&type=style&index=0&id=f342791c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f342791c",
  null
  
)

export default component.exports